export const CARD_TYPES = {
  REGULAR: 'REGULAR',
  SMALL: 'SMALL',
} as const;

export type CardType = keyof typeof CARD_TYPES;

export const CARD_SIZES: Record<CardType, { WIDTH: number; HEIGHT: number }> = {
  REGULAR: {
    WIDTH: 144,
    HEIGHT: 208,
  },
  SMALL: {
    WIDTH: 23,
    HEIGHT: 34,
  },
};
